<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16d39qd/images/9781439669105.jpg?1684514749620" alt="This image is the cover for the book Cleveland's Rock and Roll Venues, Images of Modern America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cleveland's Rock and Roll Venues, Images of Modern America
      </h1>
      <p class="bookDescription body article font2">
        <p>Cleveland has always been a music town. And thanks to Cleveland deejay Alan Freed, who booked the first venue for rock enthusiasts, music fans have never lacked for places to go see their favorite acts perform in person. This book honors the astute owners and their venues--from yesterday to today--that present fans with the music they crave. The early clubs helped usher in Cleveland as the designated Rock and Roll Capital of the World. Today's venues continue the tradition, thus ensuring that music lovers of all ages, and attitudes, get to enjoy their rock and roll on the North Coast, with all its variety and talent. Because of them, musical memories continue to be made.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deanna R. Adams, Janet Macoska
      </h2>
      
      <p class="authorDescription body article">Deanna R. Adams is an award-winning writer, speaker, essayist, and author of eight books, fiction and nonfiction. She is the longtime coordinator of the Western Reserve Writers' Conference and "Book Whisperer" for the Cuyahoga County Library's William N. Skirball Writers' Center. She also teaches online writing courses for the Pennwriters organization. She is a proud native Clevelander and shares her love of rock and roll with husband, Jeff. Her website is www.deannaadams.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?087f3d0c